import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import { green, red } from '@material-ui/core/colors'; 
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import {pending} from '../stores/State'
import CompareArrows from '@material-ui/icons/CompareArrows';
import PALLET_SIZE from '../models/PalletSize'
import TRANSACTION_TYPE from '../models/TransactionType'
import CheckCircle from '@material-ui/icons/CheckCircle';
import TransactionsTable from './TransactionsTable';

@inject('store')
@observer
class InventoryLocationTransactions extends Component {
  
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props, nextProps)) this.fetchTransactions(nextProps.inventoryLocationId);
  }

  componentDidMount(){
    this.fetchTransactions();
  }

  fetchTransactions(inventoryLocationId){
    const uiStore = this.props.store.inventoryLocationTransactionsUIStore;    
    
    const store = this.props.store.transactionStore;
    store.fetchInventoryLocationTransactions(inventoryLocationId || this.props.inventoryLocationId, uiStore.rowsPerPage, uiStore.page);
  }

  handlePageChange(page){
    const uiStore = this.props.store.inventoryLocationTransactionsUIStore;    
    uiStore.setPage(page);
    this.fetchTransactions();
  }

  handleRowsPerPageChange(rowsPerPage){
    const uiStore = this.props.store.inventoryLocationTransactionsUIStore;    
    uiStore.setRowsPerPage(rowsPerPage);
    this.fetchTransactions()
  }

  handleRowClick(transaction){
    this.props.history.push(`/groups/${transaction.campaign_prefix}/tokens/${transaction.token}`);        
  }

  render() {
    const { classes } = this.props;
    const store = this.props.store.transactionStore;
    const uiStore = this.props.store.inventoryLocationTransactionsUIStore;
    
    return (
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><CompareArrows/>Transactions</Typography>
        { store.transactionsState === pending && <CircularProgress /> }
        { store.transactions && 
          <TransactionsTable
            transactions={store.transactions.results}
            count={store.transactions.count}
            rowsPerPage={uiStore.rowsPerPage}
            page={uiStore.page}
            onChangePage={(event, page)=>this.handlePageChange(page)}
            onChangeRowsPerPage={(event)=>this.handleRowsPerPageChange(event.target.value)}
            handleRowClick={this.handleRowClick.bind(this)}
          /> }
        </Paper>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  },
  addIcon:{
    color: green[500]
  },
  removeIcon:{
    color: red[500]
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

export default withRouter(withStyles(styles)(InventoryLocationTransactions));



// WEBPACK FOOTER //
// ./src/components/InventoryLocationTransactions.js